import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import TextField from '@mui/material/TextField';


const AutoComplete = ({
  label, textFieldProps = {}, renderInput, ...autoCompleteProps
}) => {
  const mergedRenderInput = (params) => {
    const mergedInputProps = { ...params.inputProps, ...(textFieldProps.inputProps || {}) };
    return (
      <TextField
        {...params}
        {...textFieldProps}
        label={label}
        inputProps={mergedInputProps}
      />
    );
  };

  return (
    <Autocomplete
      {...autoCompleteProps}
      renderInput={renderInput || mergedRenderInput}
    />
  );
};

export default AutoComplete;
